import classNames from 'classnames';
import ReactPaginate from 'react-paginate';
import type { ReactPaginateProps } from 'react-paginate';

import styles from './_index.module.scss';

export interface PaginationProps extends ReactPaginateProps {
  'data-testid'?: string;
  nextLabel?: string;
  onPageChange?: (selectedItem: { selected: number }) => void;
  pageCount: number;
  pageRangeDisplayed?: number;
  previousLabel?: string;
  show?: boolean;
  variant?: 'default' | 'dots';
}

function Pagination({
  className,
  'data-testid': dataTestId,
  nextLabel = 'Next >',
  onPageChange,
  pageCount,
  pageRangeDisplayed = 5,
  previousLabel = '< Prev',
  show,
  variant = 'default',
  ...other
}: PaginationProps) {
  if (!show) {
    return null;
  }
  const isDotsVariant = variant === 'dots';

  return (
    <div data-testid={dataTestId}>
      <ReactPaginate
        activeClassName={styles['pagination-active']}
        breakLabel="..."
        className={classNames(styles['pagination'], className, {
          [styles['pagination-dots']]: isDotsVariant,
        })}
        disabledClassName={styles['pagination-disabled']}
        nextLabel={isDotsVariant ? '→' : nextLabel}
        onPageChange={onPageChange}
        pageCount={pageCount}
        pageLinkClassName={isDotsVariant ? styles['page-dot'] : undefined}
        pageRangeDisplayed={pageRangeDisplayed}
        previousLabel={isDotsVariant ? '←' : previousLabel}
        renderOnZeroPageCount={null}
        {...other}
      />
    </div>
  );
}

export default Pagination;
